import { capitalizeWords } from "../../../helpers/helpers";

export const OTHERS_DESIGNATION_VALUE = "OTHERS";

export const isOthersName = (name) =>
  String(name || "")
    .trim()
    .toLowerCase() === "others";

export const isOthersDesignation = (value, designations = []) => {
  if (!value) return false;
  if (value === OTHERS_DESIGNATION_VALUE) return true;
  const selected = designations.find((d) => d.designationId === value);
  return isOthersName(selected?.designationName);
};

export const resolveDesignationName = (values, designations = []) => {
  if (isOthersDesignation(values?.designationId, designations)) {
    return values?.customDesignation?.trim();
  }
  return designations
    .find((d) => d.designationId === values?.designationId)
    ?.designationName?.trim();
};

export const buildDesignationOptions = (designationsData = []) => {
  const options =
    designationsData?.map((desig) => ({
      value: desig.designationId,
      label: capitalizeWords(desig.designationName),
    })) || [];

  if (!designationsData?.some((d) => isOthersName(d.designationName))) {
    options.push({ value: OTHERS_DESIGNATION_VALUE, label: "Others" });
  }

  return options;
};

export const DEPARTMENT_OPTIONS = [
  { label: "Finance", value: "Finance" },
  { label: "Accounts Payable", value: "Accounts Payable" },
  { label: "Procurement", value: "Procurement" },
  { label: "Legal & Compliance", value: "Legal & Compliance" },
  { label: "Operations", value: "Operations" },
  { label: "Supply Chain & Logistics", value: "Supply Chain & Logistics" },
  { label: "Human Resources", value: "Human Resources" },
  { label: "Executive / Management", value: "Executive / Management" },
  { label: "Sales & Marketing", value: "Sales & Marketing" },
];
